import { z } from 'zod';
import { Platform, WatchlistType } from '../enums';

export const clientWatchlistSchema = z.object({
  id: z.string(),
  clientId: z.string().uuid(),
  type: z.nativeEnum(WatchlistType),
  platform: z.nativeEnum(Platform),
  handle: z.string(),
  displayName: z.string().nullable(),
  notes: z.string().nullable(),
  enabled: z.boolean(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type ClientWatchlistSchema = z.infer<typeof clientWatchlistSchema>;
